import { PluginSetup as RtspSetup } from '@leverege/ui-video'
import { PluginSetup as RsrcSetup } from '@leverege/api-ui-rsrc-management'

import PluginSetup from './plugins/PluginSetup'
import Screens from './screens/PluginSetup'
// import Forms from './plugins/imageCapture/PluginSetup.js'

const install = ( molten ) => {
  PluginSetup.install( molten )
  Screens.install( molten )
  RtspSetup.install( molten )
  RsrcSetup.install( molten )
  // Forms.install( molten )
}

export default { install }
